import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"
import { cn } from "@/lib/utils"


const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap outline-none group/btn rounded-sm text-sm font-medium transition-colors  disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default:"bg-theme text-white hover:bg-theme/90",
        gray:"bg-backgroundV1 border border-borderV1",
        outline:"bg-transparent border !border-theme !text-theme hover:border-[#2487EE]  hover:text-[#2487EE]",
        ghost: "p-0 !bg-none",
        link: "text-primary underline-offset-4 hover:underline",
        destructive: "bg-red text-white hover:bg-red/90",
        destructiveOutline: "bg-transparent border border-red text-red hover:border-red/90 hover:text-red/90",
      },
      size: {
        default: "px-4 py-2.5",
        sm: "px-3 py-2 text-xs",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)


const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button"
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button, buttonVariants }
